import { API } from "@/lib/api";

export const QTY_OPTIONS = Array.from({ length: 20 }, (_, i) => i + 1);
export const DEFAULT_QTY = 2;

export function formatCents(cents, currency) {
  if (typeof cents !== "number" || !currency) return null;
  return new Intl.NumberFormat("en-US", { style: "currency", currency }).format(cents / 100);
}

export function quoteLines(price) {
  if (!price) return [];
  const fee = formatCents(price.booking_fee_eur_cents, "EUR");
  if (!price.combined_total_withheld) {
    return [`${formatCents(price.provider_quote_total_cents, "EUR")} provider quote (incl. ${fee} booking fee)`];
  }
  return [
    `${formatCents(price.net_subtotal_cents, price.currency)} provider net (excl. booking fee)`,
    `+ ${fee} booking fee charged separately; combined total withheld`,
  ];
}

export function seatingLabel(seating) {
  if (seating?.together === "provider_states_together") return `Seated together (provider: up to ${seating.party_size_together})`;
  if (seating?.together === "not_stated_for_quantity") return `Together seating not stated for this quantity`;
  return "Seating together: unknown";
}

export const STATUS_COPY = {
  disabled: "XS2Event ticket availability isn't enabled yet.",
  loading: "Checking XS2Event now…",
  no_matching_provider_offers: "XS2Event has no tickets matching this quantity right now. That doesn't mean the event is sold out elsewhere.",
  unavailable: "XS2Event availability couldn't be checked right now.",
  rate_limited: "XS2Event is busy. Please try again shortly.",
  error: "XS2Event availability couldn't be checked right now.",
};

export function createLatestGuard() {
  let current = 0;
  return { next: () => ++current, isCurrent: (id) => id === current };
}

export async function fetchJsonNoStore(path, signal) {
  const res = await fetch(`${API}${path}`, { cache: "no-store", signal, headers: { "Cache-Control": "no-store" } });
  if (!res.ok) throw new Error("request_failed");
  return res.json();
}

export function normalizeResult(data) {
  const known = ["disabled", "available", "no_matching_provider_offers", "unavailable", "rate_limited"];
  if (!data || !known.includes(data.status)) return { status: "error", offers: [] };
  if (data.status === "available" && !(data.offers || []).length) return { ...data, status: "no_matching_provider_offers", offers: [] };
  return { ...data, offers: data.status === "available" ? data.offers : [] };
}
